import { inject, Injectable } from '@angular/core';
import { ContextService } from '@core/services/context.service';
import { DestroyableComponent } from '@models/destroyable.component';
import { Store } from '@ngrx/store';
import { IContentPane } from 'lingo2-models';
import { BehaviorSubject } from 'rxjs';

export interface OldTitlesInterface {
  title: string[];
  baseTitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class PanesService extends DestroyableComponent {
  protected context = inject(ContextService);
  private store = inject(Store);

  public _oldPanes: IContentPane[];
  public _oldCategories: IContentPane[];
  public _oldTitles: OldTitlesInterface = {
    title: null,
    baseTitle: '',
  };
  private panesLoading = this.register(new BehaviorSubject<boolean>(false));
  public panesLoading$ = this.panesLoading.asObservable();

  public set oldPanes(panes: IContentPane[]) {
    this._oldPanes = panes;
  }

  public get oldPanes() {
    return this._oldPanes;
  }

  public set oldCategories(pane: IContentPane[]) {
    this._oldCategories = pane;
  }

  public get oldCategories() {
    return this._oldCategories;
  }

  public set oldTitles(data: OldTitlesInterface) {
    this._oldTitles = data;
  }

  public get oldTitles() {
    return this._oldTitles;
  }

  public setPanesLoading(loaded: boolean) {
    this.panesLoading.next(loaded);
  }
}
